import { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

function calculatePolygonBounds(paths, maps) {
  return _.flatten((paths.getArray ? paths.getArray() : [])
    .map(path => path.getArray()))
    .reduce((bounds, point) =>
      bounds.extend(point), new maps.LatLngBounds(),
    );
}

export default class Polygon extends Component {
  constructor(props) {
    super(props);
    this.shape = null;
  }


  componentWillMount() {
    this.shape = new this.props.maps.Polygon({
      clickable: !!this.props.info,
      strokeColor: this.props.strokeColor,
      strokeOpacity: this.props.strokeOpacity,
      strokeWeight: this.props.strokeWeight,
      fillColor: this.props.fillColor,
      fillOpacity: this.props.fillOpacity,
      map: this.props.map,
      paths: this.props.paths,
    });

    const bounds = calculatePolygonBounds(this.shape.getPaths(), this.props.maps);
    this.props.handleBounds(bounds);

    if (this.props.info) {
      this.infoWindow = new this.props.maps.InfoWindow({
        content: this.props.info.content,
        position: bounds.getCenter(),
      });
      this.openInfoWindow = () => this.infoWindow.open(this.props.map, this.shape);

      this.shape.addListener('click', this.openInfoWindow);
    }

    this.shape.setMap(this.props.map);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.map !== nextProps.map) {
      this.shape.setMap(nextProps.map);
    }


    if (!_.isEqual(this.props.paths, nextProps.paths)) {
      this.shape.setPaths(nextProps.paths);
      const bounds = calculatePolygonBounds(this.shape.getPaths(), nextProps.maps);
      this.props.handleBounds(bounds);

      if (this.infoWindow) {
        this.infoWindow.setCenter(bounds.getCenter());
      }
    }
  }

  componentWillUnmount() {
    this.props.handleBounds(null);
    this.shape.setMap(null);
  }

  render() {
    return null;
  }
}

Polygon.defaultProps = {
  info: undefined,
  strokeColor: '#FF0000',
  strokeOpacity: 0.8,
  strokeWeight: 2,
  fillColor: '#FF0000',
  fillOpacity: 0.35,
};

Polygon.propTypes = {
  paths: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired,
      }),
    ).isRequired,
  ).isRequired,
  handleBounds: PropTypes.func.isRequired,

  // Info
  info: PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  }),

  // Styling
  strokeColor: PropTypes.string,
  strokeOpacity: PropTypes.number,
  strokeWeight: PropTypes.number,
  fillColor: PropTypes.string,
  fillOpacity: PropTypes.number,

  // Google Maps map instance
  map: PropTypes.object.isRequired, // eslint-disable-line
  // Google Maps lib reference
  maps: PropTypes.object.isRequired, // eslint-disable-line
};
